import { Injectable, inject } from '@angular/core' ;
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router' ;
import { Observable } from 'rxjs' ;
import { AssetPreloaderService } from '../../core/services/asset-preloader.service';
import { StudentDataService } from '../../core/services/student-data.service';

export const taskSelectResolver = () => {
  const studentDataService = inject(StudentDataService);
  let imageList: string[] = [
    studentDataService.getTaskSelectBackground(),
    ...studentDataService.getTaskSelectButtonImages()
  ]

  return inject(AssetPreloaderService).preloadImages(imageList) ;
}
